import React, { useState } from "react";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import OTPInputField from "../../ui/CustomOtpInput/OTPInputField";
import { useConfirmOtpForgotPassword } from "../../lib/queries/queriesAndMutations";
import { PeToEn } from "../../utils/utils";

const OtpForgotPasswordPage = (props) => {
  const [otp, setOtp] = useState("");
  const navigate = useNavigate();
  const { state } = useLocation();
  const { mutateAsync: confirmOtp } = useConfirmOtpForgotPassword();

  const processForm = async (data) => {
    const phone = state.phone;

    if (!phone) {
      toast.error("شماره تلفن را وارد نمایید");
      return;
    }
    if (String(otp).length !== 6) {
      toast.error(" کد ارسالی 6 رقمی است");
      return;
    }
    try {
      const response = await confirmOtp({ phone, otp: PeToEn(otp) });

      if (response.status === 200) {
        navigate("/confirm-new-password", {
          state: { phone, otp: PeToEn(otp) },
        });
      }
    } catch (error) {
      console.error("sendEmail", error);
    }
  };

  return (
    <div className="figure-wrapper">
      <p className="text-[#7f7f7f] text-[14px] md:text-[16px] mb-3  font-bold   text">
        کاربر گرامی
        <br /> جهت تغییر رمز عبور، کد تایید5رقمی ارسال شده به {state?.phone} را
        وارد نمایید
      </p>

      <div className="flex flex-col gap-2 " dir="ltr">
        <OTPInputField
          value={otp}
          handleChange={setOtp}
          styleObject={{ backgroundColor: "#F0F0F0" }}
          numOfInputs={6}
        />

        <button
          onClick={processForm}
          className="text-[#FFFFFF] bg-dark hover:bg-[#2A7A67] py-[12px]  px-[70px] rounded-[12px] mt-4 text-[22px] w-fit mx-auto font-semibold"
        >
          تایید کد
        </button>
      </div>
    </div>
  );
};

export default OtpForgotPasswordPage;
